import axios from 'axios';


export const getMaterialKpi=(where:string)=>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`material/graph?where=`+where 
  );
}

